import { render } from "./FloatingContact.vue?vue&type=template&id=646a2b43&scoped=true"
import script from "./FloatingContact.vue?vue&type=script&lang=js"
export * from "./FloatingContact.vue?vue&type=script&lang=js"

import "./FloatingContact.vue?vue&type=style&index=0&id=646a2b43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646a2b43"]])

export default __exports__